export default __webpack_public_path__ + "static/media/logo.0f81e0a8.png";